import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';

let imgTimeout = null

class blurImg extends React.PureComponent {
  static propTypes = {
    placeHolder: PropTypes.string,
    originSrc: PropTypes.string.isRequired,
    altText: PropTypes.string,
    addStyle: PropTypes.string,
  };

  static defaultProps = {
    placeHolder: undefined,
    altText: undefined,
    addStyle: '',
  }
  state = {
    imgError: false,
  }
  componentDidMount() {
    this.loadOriginImg()
  }

  componentWillUnmount() {
    window.clearTimeout(imgTimeout)
  }

  imgLoad = (src, resFunc) => {
    const timeoutPromoise = new Promise((resolve, reject) => {
      imgTimeout = window.setTimeout(() => { reject() }, 8000)
    })

    const imgPromise = new Promise((resolve, reject) => {
      const image = new Image();
      image.src = src;
      image.onload = () => {
        if (image.complete) resolve(image)
        reject(image)
      }
      // image.onerror = () => { reject(image) }
    })

    Promise.race([imgPromise, timeoutPromoise])
    .then((res) => {
      resFunc(res)
    })
    .catch((err) => {
      console.log(err)
      // this.setState({
      //   imgError: true,
      // })
    })
  }

  loadOriginImg = () => {
    const { originSrc } = this.props
    this.imgLoad(originSrc, (img) => {
      this.wrapper.replaceChild(img, this.wrapper.firstChild)
    })
  }

  render() {
    const { addStyle, placeHolder, altText } = this.props
    const { imgError } = this.state
    return (
      <div
        className={`${s.container} ${addStyle || ''}`}
        ref={(ref) => { this.wrapper = ref }}
      >
        <img src={placeHolder} alt={altText || '加载中...'} />
        {!imgError ? null :
        <div // eslint-disable-line
          className={s.reload}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            this.loadOriginImg()
            this.setState({
              imgError: false,
            })
          }}
        >加载失败，请点击重试</div>}
      </div>
    );
  }
}

export default withStyles(s)(blurImg);



// WEBPACK FOOTER //
// ./src/components/common/BlurImg/index.js